// extracted by mini-css-extract-plugin
export var checked = "ImageCheckbox-module--checked--XQva-";
export var checkedIcon = "ImageCheckbox-module--checkedIcon--RLwz6";
export var mainIcon = "ImageCheckbox-module--mainIcon--o4lBd";
export var root = "ImageCheckbox-module--root--1W3Kc";
export var styledCheckbox = "ImageCheckbox-module--styledCheckbox--XGuwa";